import { ApiService } from '@libs-uuif/shared/api-service';
import { sessionStorageKeeperService } from '../auth-service';

const urlPostfix = '/api/manager';

export class NsmApiService {
  nsmApiWrapper = new ApiService();

  getSsoToken(baseUrl: string, data: any) {
    const nsmBaseUrl = `${baseUrl}${urlPostfix}`;
    this.nsmApiWrapper = new ApiService(nsmBaseUrl);
    return this.nsmApiWrapper.post<any>('/auth/sso', data);
  }

  getApiData(endpoint: string, params: any, tenantGroup?: string) {
    return this.nsmApiWrapper.get<any>(endpoint, {
      params,
      headers: {
        ...this.getDefaultHeaders(),
        ...this.getGroupHeader(tenantGroup ? tenantGroup : ''),
      },
    });
  }

  createReport(endpoint: string, data: any, params: any) {
    return this.nsmApiWrapper.post<any>(endpoint, data, {
      params,
      headers: this.getDefaultHeaders(),
    });
  }

  runTaskConfig(endpoint: string, id: any[], startTS = 0, endTS = 0, force: boolean) {
    return this.nsmApiWrapper.post<any>(endpoint, { id, startTS, endTS, force } , {
      headers: this.getDefaultHeaders(),
    });
  }

  fetchNsmToken() {
    return sessionStorageKeeperService.retrieve('nsmToken') || '';
  }

  getDefaultHeaders() {
    return {
      Authorization: this.fetchNsmToken(),
    };
  }

  getGroupHeader(tenantGroup: string) {
    if (tenantGroup !== '') {
      return { 'X-GROUP-ID': tenantGroup };
    }
    return {};
  }

  activateTenant(tenantIDs: string[]) {
    return this.nsmApiWrapper.put<any>('/tenants/active', { tenantIDs }, { headers: { ...this.getDefaultHeaders() } });
  }

  getAllTenants() {
    return this.nsmApiWrapper.get<any>('/tenants', {
      headers: { ...this.getDefaultHeaders() },
    });
  }

  getTenantGroups() {
    return this.nsmApiWrapper.get<any>('/deviceGroups/tenant', {
      headers: { ...this.getDefaultHeaders() },
    });
  }
}

export const nsmApiService = new NsmApiService();
